import type {
  CancellationPolicyKind,
  ICancellationPolicyStage,
} from '@lt/components/components/CancellationPolicy/assets/types';
import type { PackageStateType } from './types';

export const cancellationPolicyDTO = (
  data: unknown,
): PackageStateType['cancellation_policy'] => {
  if (data && typeof data === 'object') {
    return {
      id:
        'id' in data &&
        (typeof data.id === 'number' || typeof data.id === 'string')
          ? data.id
          : 0,
      kind: 'kind' in data ? cancellationPolicyKindDTO(data.kind) : 'flexible',
      description:
        'description' in data && typeof data.description === 'string'
          ? data.description
          : undefined,
      flight_date:
        'flight_date' in data && typeof data.flight_date === 'string'
          ? data.flight_date
          : '',
      stages:
        'stages' in data ? cancellationPolicyStagesDTO(data.stages) : undefined,
      cancelated_at:
        'cancelated_at' in data && typeof data.cancelated_at === 'string'
          ? data.cancelated_at
          : undefined,
      nowDateISO:
        'nowDateISO' in data && typeof data.nowDateISO === 'string'
          ? data.nowDateISO
          : undefined,
    };
  }

  return null;
};

const cancellationPolicyKindDTO = (data: unknown): CancellationPolicyKind => {
  if (
    data &&
    (data === 'flexible' || data === 'moderate' || data === 'strict')
  ) {
    return data;
  }

  return 'flexible';
};

const cancellationPolicyStagesDTO = (
  data: unknown,
): ICancellationPolicyStage[] | undefined => {
  if (data && Array.isArray(data)) {
    return data.map((stage) => ({
      refund_amount:
        'refund_amount' in stage && typeof stage.refund_amount === 'number'
          ? stage.refund_amount
          : null,
      start_date:
        'start_date' in stage && typeof stage.start_date === 'string'
          ? stage.start_date
          : null,
      return_type:
        'return_type' in stage &&
        (stage.return_type === 'full' ||
          stage.return_type === 'partial' ||
          stage.return_type === 'nothing')
          ? stage.return_type
          : null,
      end_date:
        'end_date' in stage && typeof stage.end_date === 'string'
          ? stage.end_date
          : null,
    }));
  }

  return undefined;
};
